import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';

const generateCorner = (
  start: { x: number; y: number },
  width: number,
  height: number
) => {
  return [
    `
        l 0,${height}
        l ${width},0
        m ${-width},0
    `,
    { x: start.x, y: start.y + height },
  ] as const;
};

export default React.forwardRef<
  SVGSVGElement,
  {
    count: number;
    firstHeight?: number;
    firstWidth?: number;
    regularHeight?: number;
    regularWidth?: number;
    extColor?: string;
  }
>(function IconTreeLine(
  {
    count,
    firstHeight = 51,
    firstWidth,
    regularHeight = 74,
    regularWidth = 57,
    extColor,
  },
  ref
) {
  const {
    spacings: { search },
  } = useContext(UiContext);

  firstWidth = search.firstLvlWidth;
  regularWidth = search.secondLvlWidth;

  const theme = useTheme();
  const stroke = extColor || theme.palette.custom.borders;

  const width = 57;
  // В случае если count === 0 - рисуем просто минус с шириной firstWidth
  const height = regularHeight * count || 1;

  const corners: string[] = [];

  let currentCoordinates = {
    x: 0,
    y: 0,
  };

  for (let i = 0; i < count; i++) {
    const [corner, newCoordinates] = generateCorner(
      currentCoordinates,
      regularWidth,
      i === 0 ? firstHeight : regularHeight
    );
    corners.push(corner);
    currentCoordinates = newCoordinates;
  }

  return (
    <svg
      ref={ref}
      className={cx('icon', 'icon-disabled')}
      style={{ overflow: 'visible' }}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinejoin="miter"
        strokeWidth={1}
        stroke={stroke}
        fill="none"
        d={`
        M 0,0
        l ${firstWidth},0
        m ${-firstWidth},0
        l -0.5,0
        m 0.5,0
        ${corners.join(' ')}
        `}
      />
    </svg>
  );
});
